import {
	throttle,
	debounce
} from '@/utils/util'

export const infiniteScroll = {
	bind(el, binding, vnode) {
		let delay = binding.value.delay | 500
		if (el.addEventListener) {
			el.addEventListener('scroll', throttle(function() {
				let scrollTop = el.scrollTop;
				if (((el.scrollHeight - el.offsetHeight) - scrollTop) < binding.value.offsetTop || 10) {
					binding.value.fn()
				}
			}, delay), false)

		} else {
			//兼容ie
			el.attachEvent('onscroll', throttle(function() {
				let scrollTop = el.scrollTop;
				if (((el.scrollHeight - el.offsetHeight) - scrollTop) < binding.value.offsetTop || 10) {
					binding.value.fn()
				}
			}, delay))
		}
	}
}
export const keyup = {
	bind(el, binding, vnode) {
		let delay = binding.value.delay | 500
		if (el.addEventListener) {
			el.addEventListener('keyup', debounce(function() {
				binding.value.fn()
			}, delay), false)

		} else {
			//兼容ie
			el.attachEvent('onkeyup', debounce(function() {
				binding.value.fn()
			}, delay))
		}
	}
}
//select 无限滚动
export const loadMore = {
	bind(el, binding) {
		// 获取element-ui定义好的scroll盒子
		const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
		SELECTWRAP_DOM.addEventListener('scroll', function() {

			const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
			if (CONDITION) {
				binding.value()
			}
		})
	}
}
